import React from "react";
import MoreButton from "./MoreButton";

const Process = [
    {
        imgSrc: "/img/salesforce/snowflake-banner-img.png",
        description: "Snowflake, https://www.snowflake.com/"
    }
];

const FeatureSnowflakeHead = () => {
    return (
        <div className="relative overflow-hidden bg-white">
            <div className="pb-16 pt-16  sm:pb-40 sm:pt-24 lg:pb-48 lg:pt-40">
                <div className="relative mx-auto flex max-w-7xl flex-col justify-between gap-[50px] px-5 sm:static sm:flex-row sm:px-10 lg:items-start lg:gap-4 lg:px-8">
                    <div className="sm:max-w-lg">
                        <h1 className="font-bold tracking-tight text-gray-900 text-h1">
                            스노우플레이크
                            <br />
                            디지털 트렌스포메이션
                        </h1>
                        <p className="mt-4 font-bold text-brand text-h3">
                            상호운용 가능한 스토리지, 탄력적 컴퓨팅, CORTEX AI,
                            클라우드 서비스, SNOWGRID
                        </p>
                        <p className="mt-4 text-gray-500 text-body">
                            &quot;많은 조직이 Snowflake를 통해 데이터, 앱, AI
                            기술을 활용하며 팀 간 협업을 실현하고 성과를
                            창출하고 있습니다. 지금 바로 글로벌 네트워크에
                            참여하세요.&quot;
                        </p>
                        <MoreButton className="mt-7" />
                    </div>
                    {Process.map(list => (
                        <div
                            key={list.description}
                            className="rounded-[30px] lg:w-[100%]"
                        >
                            <img
                                src="/img/salesforce/snowflake-main-banner.png"
                                alt=""
                                className="h-full w-full object-cover object-center"
                            />
                            <p className="text-right text-gray-400">
                                {list.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FeatureSnowflakeHead;
